import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceChart',
  props: {
  containerId: { type: String, required: true } /** Id for TV iframe */,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.containerId,
    class: "chart-container"
  }, null, 8, _hoisted_1))
}
}

})